import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL } from './utils';

const ID = '22';
const IABid = [69];

export const createPixel = (consentData?: string | null): HTMLImageElement => {
  const img = document.createElement('img');
  img.style.display = 'none';
  const redirect = getUserSyncURL(ID);
  if (consentData) {
    img.src = `https://us-u.openx.net/w/1.0/cm?gdpr=1&gdpr_consent=${consentData}&id=de2d90e5-4d26-4c8c-a342-3edcde51fdb1&ph=25af9286-f23b-4b02-abcd-f2ee3b564dab&r=${redirect}`;
  } else {
    img.src = `https://us-u.openx.net/w/1.0/cm?gdpr=0&gdpr_consent=&id=de2d90e5-4d26-4c8c-a342-3edcde51fdb1&ph=25af9286-f23b-4b02-abcd-f2ee3b564dab&r=${redirect}`;
  }

  return img;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    if (context.gdprConsent.consent?.gdprApplies) {
      const img = createPixel(context.gdprConsent.consent.tcString);
      fastdom.mutate(function userSyncOpenrtbCMPAddElement() {
        document.body.appendChild(img);
      });
    } else {
      const img = createPixel();
      fastdom.mutate(function userSyncOpenrtbAddElement() {
        document.body.appendChild(img);
      });
    }
  }),
);
